export default __webpack_public_path__ + "static/media/page1-img_05.44bc4ccf.jpg";